import s from './CustomRadioElem.module.css';
import '../and-design.css';
import {Select,} from "antd";
import React, { useState} from "react";
import classNames from "classnames";
import UserImage from "@common/Chat/components/UserImage/UserImage";

const CustomRadioElem = ({user, addUsers, participants, setParams}) => {
    const [role, setRole] = useState('member');
    const [isSelect, setSelected] = useState(false)

    let isItSelectedParticipant = participants.find(el => el.id === user.id)
    const options = [
        {
            label: 'Администратор',
            value: 'admin'
        },
        {
            label: 'Участник',
            value: 'member'
        },
        {
            label: 'Читатель',
            value: 'reader'
        }
    ]

    const toggleAddUser = () => {
        setSelected(!isSelect)
        isItSelectedParticipant ? addUsers([...participants.filter(el => el.id !== user.id)]) : addUsers([...participants, {
            id: user.id,
            name: user.name,
            avatar: user.avatar_path,
            role: role
        }])
        // Сбрасываем только строку поиска: active и count должны сохраниться,
        // иначе список начинает показывать неактивных пользователей.
        setParams((prev) => ({...prev, search: ''}))
    }

    return (
        <div className={classNames(s.row, 'custom-radio-element')}>
            <div className={s.rowHead}>
                <UserImage path={user.avatar_path}/>
                <div className={s.rowName}>{user.name}</div>
            </div>
            <div className={s.controls}>
                <Select
                    onChange={(value) => {
                        setRole(value)
                        if(isItSelectedParticipant){
                            addUsers((prev)=>{
                                return (
                                    prev.map((el)=>{
                                        if(el.id === user.id){
                                            return(
                                               {
                                                ...el,
                                                role: value,
                                               } 
                                            )
                                        }
                                        return el
                                    })
                                )
                            })
                        }
                    }}
                    options={options} value={role}
                    popupClassName={'custom-dropdown'}
                    size={'middle'}
                    dropdownStyle={{ fontSize: '12px', background: 'var(--color-surface)' }}
                >
                    <Select.Option value="admin" className={s.option}>Администратор</Select.Option>
                    <Select.Option value="member">Участник</Select.Option>
                    <Select.Option value="reader">Читатель</Select.Option>
                </Select>
                <div className={s.selectContainer} onClick={toggleAddUser}>
                    <div className={isItSelectedParticipant ? s.selected : s.select}></div>
                </div>
                {isSelect}
            </div>

        </div>
    )
}

export default CustomRadioElem;
